// [minZipPrefix, maxZipPrefix, stateTaxRate] — 3-digit ZIP prefix ranges to state base sales tax rate
export const ZIP_TAX_RATES: Array<[number, number, number]> = [
	[5, 5, 0.04], [6, 9, 0], [10, 27, 0.0625],
	[28, 29, 0.07], [30, 38, 0], [39, 49, 0.055],
	[50, 59, 0.06], [60, 69, 0.0635], [70, 89, 0.06625],
	[100, 149, 0.04], [150, 196, 0.06],
	[197, 199, 0], [200, 205, 0.06], [206, 219, 0.06],
	[220, 246, 0.053], [247, 268, 0.06], [270, 289, 0.0475],
	[290, 299, 0.06], [300, 319, 0.04], [320, 349, 0.06],
	[350, 369, 0.04], [370, 385, 0.07], [386, 397, 0.07],
	[400, 427, 0.06], [430, 459, 0.0575], [460, 479, 0.07],
	[480, 499, 0.06], [500, 528, 0.06], [530, 549, 0.05],
	[550, 567, 0.06875], [570, 577, 0.045], [580, 588, 0.05],
	[590, 599, 0], [600, 629, 0.0625], [630, 658, 0.04225],
	[660, 679, 0.065], [680, 693, 0.055], [700, 714, 0.0445],
	[716, 729, 0.065], [730, 749, 0.045], [750, 799, 0.0625],
	[800, 816, 0.029], [820, 831, 0.04], [832, 838, 0.06],
	[840, 847, 0.061], [850, 865, 0.056], [870, 884, 0.05125],
	[889, 898, 0.0685], [900, 961, 0.0725],
	[967, 968, 0.04], [970, 979, 0], [980, 994, 0.065],
	[995, 999, 0]
];
